import clsx from 'clsx';

interface DayItemProps {
  dia: {
    diaSemana: string;
    data: string;
    mes: string;
  };
  disabled?: boolean;
  selected: boolean;
  onClick: () => void;
}

const DayItem = ({ dia, selected, disabled, onClick }: DayItemProps) => (
  <button
    type="button"
    disabled={disabled}
    onClick={() => !disabled && onClick()}
    className={clsx(
      'mr-4 md:mr-0 scroll-smooth scroll-snap-align-center',
      'flex flex-col items-center justify-center min-w-[76px] w-[76px] h-14 p-2',
      'border border-ins-blue rounded-lg',
      selected ? 'bg-ins-blue text-white' : 'text-ins-blue bg-transparent',
      disabled
        ? 'cursor-not-allowed opacity-50 bg-gray-200 text-gray-500 hover:none'
        : 'cursor-pointer group hover:bg-ins-blue hover:text-white'
    )}
  >
    <span className="text-xs font-normal mb-1">{dia.diaSemana}</span>
    <span
      className={clsx(
        'text-xs font-semibold',
        selected ? 'text-white' : 'text-ins-blue',
        !disabled && 'group-hover:text-white'
      )}
    >
      {dia.data}
    </span>
    <span
      className={clsx(
        'text-xs',
        selected ? 'text-white' : 'text-ins-blue',
        !disabled && 'group-hover:text-white'
      )}
    >
      {dia.mes}
    </span>
  </button>
);

export default DayItem;
